import { styled } from 'linaria/react';
import { COLORS, FONTS, BREAKPOINTS } from '../../../styles/constants';

export const StyledContainer = styled.div`
  background: ${COLORS.brown.dark[100]};
  bottom: 0;
  display: flex;
  flex-direction: column;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 10000000;

  @media screen and (min-width: ${BREAKPOINTS.s}px) {
    align-items: center;
    backdrop-filter: blur(12px);
    background-color: ${COLORS.black[25]};
    justify-content: center;
    padding: 12px;
  }
`;

export const StyledModalContent = styled.div`
  background: ${COLORS.brown.dark[100]};
  border-radius: 20px 20px 0 0;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  padding-top: 30px;
  position: relative;
  width: 100%;

  @media screen and (min-width: ${BREAKPOINTS.s}px) {
    border-radius: 20px;
    height: auto;
    max-height: calc(100dvh - 24px);
    max-width: 518px;
  }

  @media screen and (min-width: ${BREAKPOINTS.l}px) {
    max-width: unset;
    width: 548px;
  }

  @media screen and (min-width: ${BREAKPOINTS.xl}px) {
    width: 692px;
  }

  @media screen and (min-width: ${BREAKPOINTS.xxl}px) {
    border-radius: calc(20px * ${BREAKPOINTS.retinaScale});
    padding-top: calc(30px * ${BREAKPOINTS.retinaScale});
    width: calc(692px * ${BREAKPOINTS.retinaScale});
  }
`;

export const StyledViewControls = styled.div`
  align-items: center;
  display: flex;
  height: 44px;
  justify-content: space-between;
  padding: 0 12px;
  width: 100%;

  @media screen and (min-width: ${BREAKPOINTS.xxl}px) {
    height: calc(44px * ${BREAKPOINTS.retinaScale});
    padding: 0 calc(12px * ${BREAKPOINTS.retinaScale});
  }
`;

export const StyledBackButton = styled.button`
  align-items: center;
  background: transparent;
  border: none;
  border-radius: 22px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  padding: 10px;

  svg {
    height: 24px;
    width: 24px;
  }

  path {
    stroke: ${COLORS.white[100]};
  }

  @media screen and (min-width: ${BREAKPOINTS.xxl}px) {
    padding: calc(10px * ${BREAKPOINTS.retinaScale});

    svg {
      height: calc(24px * ${BREAKPOINTS.retinaScale});
      width: calc(24px * ${BREAKPOINTS.retinaScale});
    }
  }
`;

export const StyledPicksThumbnails = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
  position: relative;

  @media screen and (min-width: ${BREAKPOINTS.xxl}px) {
    gap: calc(8px * ${BREAKPOINTS.retinaScale});
  }
`;

export const StyledThumbnailWrapper = styled.div`
  align-items: center;
  display: flex;
  padding-right: 16px;

  @media screen and (min-width: ${BREAKPOINTS.xxl}px) {
    padding-right: calc(16px * ${BREAKPOINTS.retinaScale});
  }
`;

export const StyledThumbnailImage = styled.div`
  border-radius: 2px;
  height: 32px;
  overflow: hidden;
  position: relative;
  transform: rotate(-8deg);
  width: 32px;

  img {
    height: 100%;
    object-fit: cover;
    width: 100%;
  }

  @media screen and (min-width: ${BREAKPOINTS.xxl}px) {
    border-radius: calc(2px * ${BREAKPOINTS.retinaScale});
    height: calc(32px * ${BREAKPOINTS.retinaScale});
    width: calc(32px * ${BREAKPOINTS.retinaScale});
  }
`;

export const StyledCountBadge = styled.div`
  align-items: center;
  background: linear-gradient(270deg, rgba(13, 127, 175, 0.3) 0%, rgba(190, 123, 74, 0.3) 100%),
    linear-gradient(90deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 1) 100%);
  border-radius: 20px;
  color: ${COLORS.brown.dark[100]};
  display: flex;
  font: 400 12px/1.4 ${FONTS.secondary};
  height: 18px;
  justify-content: center;
  position: absolute;
  right: 0;
  top: 0;
  width: 18px;

  @media screen and (min-width: ${BREAKPOINTS.xxl}px) {
    border-radius: calc(20px * ${BREAKPOINTS.retinaScale});
    font-size: calc(12px * ${BREAKPOINTS.retinaScale});
    height: calc(18px * ${BREAKPOINTS.retinaScale});
    width: calc(18px * ${BREAKPOINTS.retinaScale});
  }
`;

export const StyledHeader = styled.div`
  padding: 32px 24px 16px;
  width: 100%;

  @media screen and (min-width: ${BREAKPOINTS.xxl}px) {
    padding: calc(32px * ${BREAKPOINTS.retinaScale}) calc(24px * ${BREAKPOINTS.retinaScale})
      calc(16px * ${BREAKPOINTS.retinaScale});
  }
`;

export const StyledTitle = styled.h1`
  color: ${COLORS.white[100]};
  font: 400 22px/1.3 ${FONTS.primary};
  margin: 0;
  max-width: 278px;

  @media screen and (min-width: ${BREAKPOINTS.xxl}px) {
    font-size: calc(22px * ${BREAKPOINTS.retinaScale});
    max-width: calc(278px * ${BREAKPOINTS.retinaScale});
  }
`;

export const StyledSearchContainer = styled.div`
  background: ${COLORS.brown.dark[100]};
  padding: 16px 24px 0;
  width: 100%;

  @media screen and (min-width: ${BREAKPOINTS.xxl}px) {
    padding: calc(16px * ${BREAKPOINTS.retinaScale}) calc(24px * ${BREAKPOINTS.retinaScale}) 0;
  }
`;

export const StyledSearchInput = styled.div`
  align-items: center;
  backdrop-filter: blur(2px);
  background: ${COLORS.white[10]};
  border-radius: 22px;
  display: flex;
  gap: 4px;
  padding: 10px 20px 10px 12px;
  width: 100%;

  svg {
    flex-shrink: 0;
    height: 24px;
    width: 24px;
  }

  svg {
    color: ${COLORS.white[100]};
  }

  @media screen and (min-width: ${BREAKPOINTS.xxl}px) {
    border-radius: calc(22px * ${BREAKPOINTS.retinaScale});
    gap: calc(4px * ${BREAKPOINTS.retinaScale});
    padding: calc(10px * ${BREAKPOINTS.retinaScale}) calc(20px * ${BREAKPOINTS.retinaScale})
      calc(10px * ${BREAKPOINTS.retinaScale}) calc(12px * ${BREAKPOINTS.retinaScale});

    svg {
      height: calc(24px * ${BREAKPOINTS.retinaScale});
      width: calc(24px * ${BREAKPOINTS.retinaScale});
    }
  }
`;

export const StyledSearchInputField = styled.input`
  background: transparent;
  border: none;
  color: ${COLORS.white[100]};
  flex: 1;
  font: 400 14px/1.4 ${FONTS.secondary};
  outline: none;

  &::placeholder {
    color: ${COLORS.brown.light[100]};
  }

  @media screen and (min-width: ${BREAKPOINTS.xxl}px) {
    font-size: calc(14px * ${BREAKPOINTS.retinaScale});
  }
`;

export const StyledListContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  scrollbar-width: none;
  width: 100%;

  &::-webkit-scrollbar {
    width: 0;
  }
`;

export const StyledListSection = styled.div<{ hasTopPadding?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: ${({ hasTopPadding }) => (hasTopPadding ? '24px' : '16px')} 0 16px;
  width: 100%;

  @media screen and (min-width: ${BREAKPOINTS.xxl}px) {
    gap: calc(16px * ${BREAKPOINTS.retinaScale});
    padding: ${({ hasTopPadding }) =>
        hasTopPadding ? `calc(24px * ${BREAKPOINTS.retinaScale})` : `calc(16px * ${BREAKPOINTS.retinaScale})`}
      0 calc(16px * ${BREAKPOINTS.retinaScale});
  }
`;

export const StyledSectionHeader = styled.div`
  padding: 0 24px 0 24px;

  @media screen and (min-width: ${BREAKPOINTS.xxl}px) {
    padding: 0 calc(48px * ${BREAKPOINTS.retinaScale}) 0 calc(24px * ${BREAKPOINTS.retinaScale});
  }
`;

export const StyledSectionTitle = styled.span`
  color: ${COLORS.white[100]};
  font: 400 14px/1.4 ${FONTS.secondary};

  @media screen and (min-width: ${BREAKPOINTS.xxl}px) {
    font-size: calc(14px * ${BREAKPOINTS.retinaScale});
  }
`;

export const StyledListItem = styled.button`
  align-items: center;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  gap: 12px;
  padding: 0 24px;
  text-align: left;
  transition: background 0.15s ease;
  width: 100%;

  &:hover {
    background: ${COLORS.white[5]};
  }

  &:active {
    background: ${COLORS.white[10]};
  }

  @media screen and (min-width: ${BREAKPOINTS.xxl}px) {
    gap: calc(12px * ${BREAKPOINTS.retinaScale});
    padding: 0 calc(24px * ${BREAKPOINTS.retinaScale});
  }
`;

export const StyledItemImage = styled.div<{ borderRadius?: number }>`
  border-radius: ${({ borderRadius }) => borderRadius ?? 8}px;
  flex-shrink: 0;
  height: 44px;
  overflow: hidden;
  position: relative;
  width: 44px;

  img,
  video {
    height: 100%;
    object-fit: cover;
    width: 100%;
  }

  @media screen and (min-width: ${BREAKPOINTS.xxl}px) {
    border-radius: ${({ borderRadius }) => `calc(${borderRadius ?? 8}px * ${BREAKPOINTS.retinaScale})`};
    height: calc(44px * ${BREAKPOINTS.retinaScale});
    width: calc(44px * ${BREAKPOINTS.retinaScale});
  }
`;

export const StyledItemImageFallback = styled.div<{ borderRadius?: number }>`
  background: linear-gradient(180deg, rgba(189, 217, 0, 0) 0%, #bdd900 100%);
  border-radius: ${({ borderRadius }) => borderRadius ?? 4}px;
  flex-shrink: 0;
  height: 44px;
  width: 44px;

  @media screen and (min-width: ${BREAKPOINTS.xxl}px) {
    border-radius: ${({ borderRadius }) => `calc(${borderRadius ?? 4}px * ${BREAKPOINTS.retinaScale})`};
    height: calc(44px * ${BREAKPOINTS.retinaScale});
    width: calc(44px * ${BREAKPOINTS.retinaScale});
  }
`;

export const StyledItemImageStack = styled.div<{ borderRadius?: number }>`
  border-radius: ${({ borderRadius }) => borderRadius ?? 8}px;
  flex-shrink: 0;
  height: 44px;
  overflow: hidden;
  position: relative;
  width: 44px;

  img {
    height: 100%;
    left: 0;
    object-fit: cover;
    position: absolute;
    top: 0;
    width: 100%;
  }

  @media screen and (min-width: ${BREAKPOINTS.xxl}px) {
    border-radius: ${({ borderRadius }) => `calc(${borderRadius ?? 8}px * ${BREAKPOINTS.retinaScale})`};
    height: calc(44px * ${BREAKPOINTS.retinaScale});
    width: calc(44px * ${BREAKPOINTS.retinaScale});
  }
`;

export const StyledItemContent = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 2px;
  justify-content: center;
  min-width: 0;

  @media screen and (min-width: ${BREAKPOINTS.xxl}px) {
    gap: calc(2px * ${BREAKPOINTS.retinaScale});
  }
`;

export const StyledItemTitle = styled.span`
  color: ${COLORS.white[100]};
  font: 400 14px/1.4 ${FONTS.primary};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media screen and (min-width: ${BREAKPOINTS.xxl}px) {
    font-size: calc(14px * ${BREAKPOINTS.retinaScale});
  }
`;

export const StyledItemSubtitle = styled.span`
  color: ${COLORS.white[60]};
  font: 400 14px/1.4 ${FONTS.secondary};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media screen and (min-width: ${BREAKPOINTS.xxl}px) {
    font-size: calc(14px * ${BREAKPOINTS.retinaScale});
  }
`;

export const StyledPrivateLabel = styled.span`
  backdrop-filter: blur(2px);
  background: linear-gradient(270deg, rgba(13, 127, 175, 0.3) 0%, rgba(190, 123, 74, 0.3) 100%),
    rgba(255, 255, 255, 0.7);
  border-radius: 999px;
  color: ${COLORS.brown.dark[100]};
  flex-shrink: 0;
  font: 500 12px/1.4 ${FONTS.secondary};
  padding: 4px 10px;

  @media screen and (min-width: ${BREAKPOINTS.xxl}px) {
    border-radius: calc(999px * ${BREAKPOINTS.retinaScale});
    font-size: calc(12px * ${BREAKPOINTS.retinaScale});
    padding: calc(4px * ${BREAKPOINTS.retinaScale}) calc(10px * ${BREAKPOINTS.retinaScale});
  }
`;

export const StyledSpacing = styled.div`
  height: 16px;
  width: 100%;

  @media screen and (min-width: ${BREAKPOINTS.xxl}px) {
    height: calc(16px * ${BREAKPOINTS.retinaScale});
  }
`;

export const StyledEmptyButton = styled.div`
  height: 44px;
  width: 44px;
`;

export const StyledMenuButtonContainer = styled.div`
  padding: 16px 24px 24px;
  flex-shrink: 0;

  @media screen and (min-width: ${BREAKPOINTS.xxl}px) {
    padding: calc(16px * ${BREAKPOINTS.retinaScale}) calc(24px * ${BREAKPOINTS.retinaScale})
      calc(24px * ${BREAKPOINTS.retinaScale});
  }
`;

export const StyledContinueButton = styled.button`
  background: transparent;
  border: none;
  color: ${COLORS.white[100]};
  cursor: pointer;
  font: 400 14px/1.4 ${FONTS.secondary};
  padding: 10px;

  @media screen and (min-width: ${BREAKPOINTS.xxl}px) {
    font-size: calc(14px * ${BREAKPOINTS.retinaScale});
    padding: calc(10px * ${BREAKPOINTS.retinaScale});
  }
`;

export const StyledConfirmationWrapper = styled.div`
  position: fixed;
  inset: 0;
  z-index: 100;
`;

export const StyledShowMoreButton = styled.button`
  background: none;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 22px;
  color: ${COLORS.white[100]};
  cursor: pointer;
  font: 600 14px/1.4 ${FONTS.secondary};
  padding: 12px 20px;
  margin: 16px auto 0;
  display: block;

  &:hover {
    background: rgba(255, 255, 255, 0.05);
  }
`;
